export default "__VITE_ASSET__DLovce3o__"